import { gql } from '@apollo/client';

type SupplierReferralEvent = {
  uuid: string;
  firstName: string | null;
  lastName: string | null;
};

type BookedSupplierReferralEvent = SupplierReferralEvent & {
  state: string | null;
  paymentDate: string | null;
};

export type SupplierReferralsResponse = {
  supplierReferrals: {
    referredEvents: SupplierReferralEvent[];
    bookedReferredEvents: BookedSupplierReferralEvent[];
  };
};

export const SUPPLIER_REFERRALS = gql`
  query supplierReferrals {
    supplierReferrals {
      referredEvents {
        uuid
        firstName
        lastName
      }
      bookedReferredEvents {
        uuid
        firstName
        lastName
        state
        paymentDate
      }
    }
  }
`;
